import React from "react";
import { Container } from "./styled";

const Container404 = () => {
  return (
    <Container>
      <h1>404</h1>
    </Container>
  );
};

export default Container404;
